import endpoints from 'constants/endpoints';
import { parseZohoJsonOutput } from 'helpers/zoho/response-parsers';
import { parseUntappedAgentsOutput } from '../untappedAgentsHelpers';

export const agencyAppointmentsKeys = {
  all: ['agency-appointments'],
  pendingAll: () => [...agencyAppointmentsKeys.all, 'pending'],
  pending: agencyId => [
    ...agencyAppointmentsKeys.pendingAll(),
    String(agencyId)
  ],
  untappedAll: () => [...agencyAppointmentsKeys.all, 'untapped-agents'],
  untapped: agencyId => [
    ...agencyAppointmentsKeys.untappedAll(),
    String(agencyId)
  ]
};

// the untapped agents Deluge function only exists in the O'Neill block, so for
// Sunshine the tab stays empty rather than erroring on a missing endpoint
export const hasUntappedAgentsEndpoint = () =>
  Boolean(endpoints?.zoho?.getAgentsWithApptInfo);

/**
 * open appointment requests for one agency, through the Zoho SafePortalProxy.
 * @param agencyId - zoho agency id
 */
export function pendingAppointmentsRequest(agencyId) {
  return {
    method: 'POST',
    // absolute url, so it bypasses the aws api baseUrl
    path: endpoints.awsProxy.safePost,
    auth: 'zohoProxy',
    data: {
      agencies: [agencyId],
      endpoint: endpoints.zoho.getPendingAppointments,
      isZohoRequest: true
    }
  };
}

/**
 * agents with no active appointment and no open request, with their available
 * carriers, through the Zoho SafePortalProxy.
 * @param agencyId - zoho agency id
 */
export function untappedAgentsRequest(agencyId) {
  return {
    method: 'POST',
    path: endpoints.awsProxy.safePost,
    auth: 'zohoProxy',
    data: {
      agencyId,
      endpoint: endpoints.zoho.getAgentsWithApptInfo,
      isZohoRequest: true
    }
  };
}

/**
 * reads the pending appointments rows out of a Deluge response. throws on an
 * unusable payload so the query lands in isError instead of caching an empty
 * success. the rows are left untagged: the agency label is applied by the hook, so
 * an agency rename never leaves a stale name sitting in the cache.
 * @param body - response body returned by the proxy
 */
export function parsePendingAppointments(body) {
  const rawOutput = body?.details?.output;
  if (rawOutput == null) {
    throw new Error('empty pending appointments response');
  }
  if (rawOutput === '') return [];
  const { data } = parseZohoJsonOutput(rawOutput);
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  return [];
}

/**
 * reads the untapped agents map out of a Deluge response, keyed by agent id.
 * @param body - response body returned by the proxy
 */
export function parseUntappedAgents(body) {
  const parsed = parseUntappedAgentsOutput(body?.details?.output);
  if (!parsed.ok) throw new Error(parsed.message || 'untapped parse failed');
  return parsed.agents;
}
